import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const InsertQuoteIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "InsertQuote",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M9.7 13.21H6.91c-.25 0-.5.03-.73.08h.03V8.31c0-.39.31-.7.7-.7H9.7a2.1 2.1 0 1 0 0-4.2H6.91c-2.71 0-4.9 2.2-4.9 4.9v8.4q0 .3.09.57c-.05.24-.08.53-.08.82v5.6c0 2.71 2.2 4.9 4.9 4.9h2.79c2.71 0 4.9-2.2 4.9-4.9v-5.6c0-2.7-2.2-4.89-4.9-4.89Zm15.39 0H22.3c-.25 0-.5.03-.73.08h.03V8.31c0-.39.31-.7.7-.7h2.8a2.1 2.1 0 1 0 0-4.2h-2.8c-2.71 0-4.9 2.2-4.9 4.9v8.4q0 .3.09.57c-.05.24-.08.53-.08.82v5.6c0 2.71 2.2 4.9 4.9 4.9h2.8c2.71 0 4.9-2.2 4.9-4.9v-5.6c0-2.7-2.2-4.89-4.9-4.89h-.01Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M16.71 29.29a1.14 1.14 0 1 1 0-2.28c.63 0 1.14-.51 1.14-1.14v-1.14h-3.43c-.63 0-1.14-.51-1.14-1.14v-4.57c0-.63.51-1.14 1.14-1.14h4.57c.63 0 1.14.51 1.14 1.14v6.86c0 1.89-1.54 3.43-3.43 3.43Zm-1.14-6.86h2.28v-2.28h-2.28zM25.86 29.29a1.14 1.14 0 1 1 0-2.28c.63 0 1.14-.51 1.14-1.14v-1.14h-3.43c-.63 0-1.14-.51-1.14-1.14v-4.57c0-.63.51-1.14 1.14-1.14h4.57c.63 0 1.14.51 1.14 1.14v6.86c0 1.89-1.54 3.43-3.43 3.43Zm-1.15-6.86H27v-2.28h-2.29zM16.71 13.29h-4.57c-.63 0-1.14-.51-1.14-1.14V5.29c0-1.89 1.54-3.43 3.43-3.43a1.14 1.14 0 1 1 0 2.28c-.63 0-1.14.51-1.14 1.14v1.14h3.43c.63 0 1.14.51 1.14 1.14v4.57c0 .63-.51 1.14-1.14 1.14ZM13.29 11h2.28V8.71h-2.28zM7.57 13.29H3c-.63 0-1.14-.51-1.14-1.14V5.29c0-1.89 1.54-3.43 3.43-3.43a1.14 1.14 0 1 1 0 2.28c-.63 0-1.14.51-1.14 1.14v1.14h3.43c.63 0 1.14.51 1.14 1.14v4.57c0 .63-.51 1.14-1.14 1.14ZM4.14 11h2.28V8.71H4.14z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M14.43 19H19v4.57h-4.57zM23.57 19h4.57v4.57h-4.57zM12.14 7.57h4.57v4.57h-4.57zM3 7.57h4.57v4.57H3z"
      })]
    })
  }));
};